module.exports = __webpack_public_path__ + "static/img/logoprosegur.e68cdb25.svg";